import { createStyles, makeStyles } from '@material-ui/core/styles';
import theme from '@yaydoo/react-components/lib/theme';

export const smartFieldStyles = {
  base: {
    fontSize: '16px',
    fontFamily: theme.typography.fontFamily,
    fontWeight: 200,
    fontSmoothing: 'antialiased',
    color: 'rgba(0, 0, 0, 0.87)',
    '::placeholder': {
      color: '#aab7c4',
    },
    iconColor: '#adbfd3',
  },
};

const styles = makeStyles((theme) =>
  createStyles({
    input: {
      '& .MuiFormLabel-root.Mui-error, .MuiFormLabel-root.Mui-disabled': {
        background: theme.oysterTheme.cotton,
        height: 'max-content',
        width: 'max-content',
      },
      '& .Mui-disabled': {
        pointerEvents: 'none',
      },
    },
    focused: {
      '& .MuiFormLabel-root': {
        transform: 'translate(14px, -6px) scale(0.75) !important',
      },
    },
    dLocalInputWrapper: {
      width: '100%',
      '& .DlocalField': {
        padding: '10px 15px',
      },
    },
  }),
);

export default styles;
